function calculateMiles(amount, ratio) {
  let miles = 0;
  if (ratio && amount > 0) miles = Math.floor((parseFloat(amount) / ratio.amount) * ratio.miles);
  return miles;
}

export default calculateMiles;
